import { useEffect, useRef } from "react";

export default function HourlyPatternChart({ hours }: { hours?: number[] }) {

    const ref = useRef<HTMLDivElement>(null);
    const chartRef = useRef<any>(null);

    useEffect(() => {
        if (!hours || !ref.current) return;
        const Apex = (window as any).ApexCharts;
        const KTUtil = (window as any).KTUtil;
        if (!Apex || !KTUtil) return;

        const labelColor = KTUtil.getCssVariableValue("--bs-gray-500");
        const borderColor = KTUtil.getCssVariableValue("--bs-gray-200");
        const primary = KTUtil.getCssVariableValue("--bs-primary");

        const labels = Array.from({ length: 24 }, (_, h) => {
            const ampm = h < 12 ? "a" : "p";
            const hr = h % 12 === 0 ? 12 : h % 12;
            return `${hr}${ampm}`;
        });

        const options = {
            series: [{ name: "Calls", data: hours }],
            chart: { type: "bar", height: 240, fontFamily: "inherit", toolbar: { show: false } },
            plotOptions: { bar: { columnWidth: "55%", borderRadius: 3 } },
            dataLabels: { enabled: false },
            legend: { show: false },
            xaxis: {
                categories: labels,
                axisBorder: { show: false },
                axisTicks: { show: false },
                labels: { style: { colors: labelColor, fontSize: "10px" } }
            },
            yaxis: { min: 0, forceNiceScale: true, labels: { style: { colors: labelColor, fontSize: "12px" } } },
            colors: [primary],
            grid: { borderColor, strokeDashArray: 4 },
            tooltip: { style: { fontSize: "12px" }, x: { formatter: (v: any) => `${v}` } }
        };

        if (chartRef.current) { try { chartRef.current.destroy(); } catch { } }
        chartRef.current = new Apex(ref.current, options);
        chartRef.current.render();

        return () => {
            if (chartRef.current) { try { chartRef.current.destroy(); } catch { } chartRef.current = null; }
        };
    }, [hours]);

    return <div ref={ref} style={{ minHeight: 240 }} />;
}
